// Keeps the last validation result visible across in-tab navigation. Start / So funktioniert's /
// Datenschutz / Impressum are separate static pages (BRIEF §5) — each a full page load, so
// clicking one and back used to silently lose whatever invoice was just checked. User feedback
// (2026-07-04): a visitor who clicks away to read something, or misclicks, should find their
// invoice still there.
//
// sessionStorage, not localStorage: persists only for the current tab/browsing session — closing
// the tab clears it, consistent with "nothing about your invoice lingers longer than your visit"
// (§3.1's spirit). Same-origin, no network involved.
import type { ValidationResult } from '../core/types';

const KEY = 'rechnungslupe:last-result';

export function saveLastResult(result: ValidationResult): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(result));
  } catch {
    /* sessionStorage can be unavailable (private browsing) or full — never let this break validation */
  }
}

export function loadLastResult(): ValidationResult | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ValidationResult) : null;
  } catch {
    return null;
  }
}
